/**
 * @module keepInPlaceOrder
 *
 * The pure slot logic behind keepInPlace (B102): no imports, so it is tested on its own.
 */
/**
 * Puts each pinned plant back at the slot it was drawn in; every other plant fills the
 * remaining slots in the given (server) order.
 *
 * @param arranged - Plant ids in the order the sort now gives.
 * @param drawn - Plant ids in the order last drawn.
 * @param pinned - Ids to hold in place.
 * @returns The ids to draw. A pinned id missing from `arranged` is left out; a slot past the end is clamped.
 */
export function keepInPlace(arranged: number[], drawn: number[], pinned: Set<number>): number[] {
  const present = new Set(arranged);
  const held: Array<[number, number]> = [];
  for (const id of pinned) {
    const slot = drawn.indexOf(id);
    if (slot >= 0 && present.has(id)) held.push([slot, id]);
  }
  held.sort((a, b) => a[0] - b[0]);
  const heldIds = new Set(held.map(([, id]) => id));
  const rest = arranged.filter((id) => !heldIds.has(id));
  const result: number[] = [];
  let r = 0;
  let h = 0;
  while (result.length < arranged.length) {
    if (h < held.length && held[h][0] <= result.length) result.push(held[h++][1]);
    else if (r < rest.length) result.push(rest[r++]);
    else result.push(held[h++][1]);
  }
  return result;
}
